export const CURRENT_USER: string = 'CURRENT_USER';
